import { PublicationDataType, PublicationEventDataType } from './executed.publication.types';

export type PublicationQueryPage = {
    data: PublicationDataType[];
    cursor?: string;
};

/**
 * Angular `PublicationOverviewController` prepends on `created` and merges
 * an existing row on `updated` for `publicationTaskChanged`.
 */
export const applyPublicationTaskEvent = (
    pages: PublicationQueryPage[],
    event: PublicationEventDataType | undefined,
): PublicationQueryPage[] => {
    const publication = event?.publication;
    if (!publication) {
        return pages;
    }

    if (event.typeOfChange === 'created') {
        if (pages.length === 0) {
            return [{ data: [publication], cursor: undefined }];
        }

        return pages.map((page, index) => {
            if (index !== 0) {
                return page;
            }

            return {
                ...page,
                data: [
                    publication,
                    ...page.data.filter((row) => row.id != publication.id),
                ],
            };
        });
    }

    if (event.typeOfChange === 'updated') {
        return pages.map((page) => ({
            ...page,
            data: page.data.map((row) =>
                row.id == publication.id
                    ? { ...row, ...publication }
                    : row,
            ),
        }));
    }

    return pages;
};
